var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","items":_vm.allLanguages,"item-text":"name","label":_vm.$t('settings.language'),"prepend-icon":_vm.$globals.icons.translate,"value":_vm.selectedItem},on:{"input":_vm.setLanguage}})}
var staticRenderFns = []

export { render, staticRenderFns }